export const normalizeUrl = (url: string): string => {
  if (!url) return '';
  try {
    const u = new URL(url, window.location.origin);
    const path = u.pathname.replace(/\/+$/, '');
    const search = u.search || '';
    return `${path}${search}`;
  } catch {
    const [rawPath, q = ''] = url.split('?');
    const path = (rawPath || '').replace(/\/+$/, '');
    const query = q ? `?${q}` : '';
    return `${path}${query}`;
  }
};

export const normalizePathname = (pathname: string): string =>
  `/${pathname}`.replace(/\/+/g, '/').replace(/\/$/, '') || '/';
